import ClientMachines from './Client/Machines';

export const AccountMachines = {
  ClientMachines,
};
